export const RU_LOCALE = 'ru';
export const EN_LOCALE = 'en';

/**
 * Возвращает локаль сайта по имени хоста.
 *
 * Домены .ru и .ru.local используют русский интерфейс.
 * Домены .com и .com.local используют английский интерфейс.
 *
 * @param {string} host Имя хоста.
 * @returns {string} Код локали или пустая строка, если домен не задает локаль.
 */
function languageFromHost(host) {
  host = (host || '').trim().toLowerCase().replace(/\.$/, '');

  if (host.endsWith('.ru') || host.endsWith('.ru.local')) {
    return RU_LOCALE;
  }
  if (host.endsWith('.com') || host.endsWith('.com.local')) {
    return EN_LOCALE;
  }
  return '';
}

/**
 * Нормализует код локали интерфейса.
 *
 * @param {string} locale Текущая локаль интерфейса, например "ru", "ru-RU", "en_US".
 * @returns {string} Нормализованный код локали "ru", "ru-ru", "en-us".
 */
export function normalizeLocale(locale) {
  return (locale || '').trim().replace(/_/g, '-').toLowerCase();
}

/**
 * Проверяет, относится ли текущая локаль интерфейса к русскому языку.
 *
 * @param {string} locale Текущая локаль интерфейса, например "ru", "ru-RU", "en_US".
 * @returns {boolean} True, если базовый язык локали русский.
 */
export function isRussianLocale(locale) {
  const language = normalizeLocale(locale).split('-')[0];
  return language === RU_LOCALE;
}

/**
 * Возвращает локаль для текущего сайта.
 *
 * Локаль из домена имеет приоритет над языком браузера.
 *
 * @returns {string} Код локали для интерфейса.
 */
export function localeForSite() {
  const hostLocale = languageFromHost(self.location && self.location.hostname);
  return hostLocale || navigator.language || EN_LOCALE;
}
